module.exports = "/currency/assets/48880bbe59c132a3743ecf71a944e664.jpg";